import type { TMessages } from '@/types/TMessages'

export const messages = {
  defaultAccount: '(по умолчанию)',
} satisfies TMessages
